import React from "react";
import { NavLink } from "react-router-dom";
import Header from "./Header";

const Project = () =>{
    return(
        <>
        <Header></Header>
        <section className="projects" id="projects">
        <div className="projects-box">
            <h2 className="heading">Projects</h2>
            <div className="wrapper">
                <div className="projects-item">
                    <img src="./assets/E-com.png" alt="E-com image" />
                    <h2>E-Commerce WEBSITE</h2>
                    <p>Developed a E-Commerce website using React.js, Redux, HTML, CSS, and Javascript
                        providing a seemless shopping experience. The platform allows user to browse products,
                        add them to a shopping cart, and securely complete purchase
                    </p>
                    <div className="btn-group">
                        <NavLink to="https://github.com/MohamedNabeel04"className="btn">GitHub</NavLink>
                    </div>
                </div>
                <div className="projects-item">
                    <img src="./assets/Calculator.png" alt="calculator image" />
                    <h2>CALCULATOR WITH TIME</h2>
                    <p>Developed a responsive Calculator application with a built-in real-time
                        digital clock using React.js. The app allows users to perform basic 
                        arithmetic operations while displaying the current time, which updates every second.
                    </p>
                    <div className="btn-group">
                        <NavLink to="https://github.com/MohamedNabeel04"className="btn">GitHub</NavLink>
                    </div>
                </div>
                <div className="projects-item">
                    <img src="./assets/Weather.png" alt="weather image" />
                    <h2>REAL-TIME WEATHER</h2>
                    <p>Developed a real-time weather application using React.js that fetches live weather data 
                        based on user input. The app integrates with the OpenWeather API to display temperature, 
                        humidity, wind speed, and weather conditions with dynamic icons.
                    </p>
                    <div className="btn-group">
                        <NavLink to="https://github.com/MohamedNabeel04"className="btn">GitHub</NavLink>
                    </div>
                </div>
            </div>
        </div>
    </section>
        </>
    )
}
export default Project;